import React, { forwardRef, useContext } from 'react';
import PropTypes from 'prop-types';

import ResultCard from './ResultCard';
import Pagination from '../Pagination';

import Select from '../Form/Select';

import { StoreContext } from './store/StoreContext';
import { GlobalsContext } from './context/globals';

function resolveExcludePlaceOfInterestValue(excludePlaceOfInterest) {
  // The default excludePlaceOfInterest is unspecified. So is specifically set to false when needed
  if (excludePlaceOfInterest === null || excludePlaceOfInterest === false) {
    return 'false';
  }

  return 'true';
}

const Results = forwardRef(({ onPagination, onUpdate }, ref) => {
  const { state } = useContext(StoreContext);
  const {
    globals: { labels, pageSize },
  } = useContext(GlobalsContext);
  const showSelect = !state.results.filter(
    (result) => result.isMeet || result.isTemporaryHolidaySite
  ).length;
  return (
    <div className="WhatsOnResults">
      <div className="WhatsOnResults_header Form Form-noBorder" ref={ref}>
        <h3 className="WhatsOnResults_resultsSummary">
          {labels.resultsSummary.replace('#{0}', state.totalResults)}
        </h3>

        {showSelect && (
          <Select
            className="WhatsOnResults_select"
            id="PlaceOfInterest"
            value={resolveExcludePlaceOfInterestValue(state.excludePlaceOfInterest)}
            onChange={(ev) =>
              onUpdate('excludePlaceOfInterest', ev.currentTarget.value === 'true' ? true : null)
            }
            options={[
              { value: 'false', label: labels.showAllLabel },
              { value: 'true', label: labels.showEventsLabel },
            ]}
          />
        )}
      </div>
      <div className="WhatsOnResults_results">
        {state.results.map((result) => (
          <ResultCard className="WhatsOnResults_resultCard" result={result} key={result.url} />
        ))}
      </div>
      <Pagination
        resultCount={state.totalResults}
        isZeroBased={true}
        page={state.page}
        pageSize={pageSize}
        onPagination={onPagination}
      />
      {state.isLoading && <div className="WhatsOnResults_loading"></div>}
    </div>
  );
});

Results.propTypes = {
  onPagination: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default Results;
